(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  class QuoteRotator extends HTMLElement {
    connectedCallback() {
      this._quotes = Array.from(this.querySelectorAll('.logo-list__quote'));
      if (this._quotes.length <= 1) return;

      this._index = 0;
      this._speed = parseInt(this.dataset.speed, 10) || 5000;
      this._startInterval();

      this.addEventListener('shopify:block:select', (event) => {
        this._stopInterval();
        const idx = this._quotes.indexOf(event.target);
        if (idx !== -1) {
          this._quotes[this._index].classList.remove('is-active');
          this._index = idx;
          this._quotes[this._index].classList.add('is-active');
        }
      });

      this.addEventListener('shopify:block:deselect', () => {
        this._startInterval();
      });
    }

    _startInterval() {
      this._interval = setInterval(() => this._rotate(), this._speed);
    }

    _stopInterval() {
      clearInterval(this._interval);
    }

    _rotate() {
      this._quotes[this._index].classList.remove('is-active');
      setTimeout(() => {
        this._index = (this._index + 1) % this._quotes.length;
        this._quotes[this._index].classList.add('is-active');
      }, 500);
    }
  }

  if (!customElements.get('quote-rotator')) {
    customElements.define('quote-rotator', QuoteRotator);
  }

  } catch(e) { console.error(e); }
})();
})();
